import { buildAppealDetailSheet, toRows } from "./principle1DetailHelpers";

export const SHEET_NAME = "Appeal or revision case details";

export function buildAppealOrRevisionCaseSheet(workbook, sectionC) {
  const essential = sectionC?.principle1?.essentialIndicators || {};
  return buildAppealDetailSheet(
    workbook,
    SHEET_NAME,
    "Details of appeal or revision case",
    toRows(essential?.appealDetails)
  );
}
